<template>
  <v-expansion-panel expand class="grey lighten-3" popout>
    <v-expansion-panel-content v-model="headerEntry">
      <div slot="header">
        <h1 class="title grey--text text--darken-1">
          <v-icon class="mr-1">{{$store.state.global.pages.allocation.icon}}</v-icon>Batch Header Entry
        </h1>
      </div>
      <div style="height: 1px;" class="grey lighten-2 mx-3 my-1"></div>
      <v-card>
        <v-card-text>
          <v-form @submit.prevent="submitBatch()" ref="batchForm">
            <layout-no-padding class="flex-container-space-between vertical-center-container">
              <v-flex sm6 md4 lg3>
                <date-picker-wrapper
                  v-model="date"
                  :rules="dateRules"
                  label="Allocation Date"
                  color="primary"
                ></date-picker-wrapper>
              </v-flex>
              <v-flex sm6 md4 lg3>
                <v-autocomplete
                  label="* Site"
                  ref="siteField"
                  :prepend-icon="$store.state.global.pages.site.icon"
                  :items="sites"
                  item-text="siteName_projectName"
                  item-value="id"
                  v-model="siteId"
                  no-data-text="An error occured"
                  :rules="siteRules"
                  :loading="loadingSites"
                  color="primary"
                ></v-autocomplete>
              </v-flex>
              <!-- <v-flex sm6 md4 lg3>
                                <v-autocomplete
                                label="* Spoil"
                                :prepend-icon="$store.state.global.pages.spoil.icon"
                                :items="spoils"
                                item-text="name"
                                item-value="id"
                                v-model="spoilId"
                                no-data-text="An error occured"
                                :rules="spoilRules"
                                :loading="loadingSpoils"  
                                color="primary"    
                                >
                                </v-autocomplete>
              </v-flex>-->
              <v-flex xs12 sm6 md4 lg3>
                <v-text-field
                  label="Notes"
                  color="primary"
                  v-model="notes"
                  :rules="notesRules"
                  prepend-icon="note"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4 lg6>
                <v-switch v-model="day" label="Day" color="amber darken-1" style="margin-top: 0px"></v-switch>
              </v-flex>
              <v-flex
                xs6
                md4
                class="text-xs-right pb-4"
                style="align-self: flex-end;"
                v-if="!!hasAllocations"
              >
                <v-btn icon flat color="grey" @click="clearFormDialog = !clearFormDialog">
                  <v-icon>clear_all</v-icon>
                </v-btn>
                <v-btn
                  :color="$store.state.global.pages.allocation.color"
                  :disabled="!hasAllocations"
                  type="submit"
                  dark
                  outline
                  :loading="addingBatch"
                >Save Batch</v-btn>
              </v-flex>
            </layout-no-padding>
          </v-form>
        </v-card-text>
      </v-card>

      <!-- ADD DRIVER COMPONENT-->
      <v-dialog
        v-model="addDriverDialog"
        max-width="500px"
        lazy
        @keydown.esc="addDriverDialog = false"
      >
        <add-driver @close="addDriverDialog = false" parentStore="dockets"></add-driver>
      </v-dialog>
      <!-- ADD VEHICLE COMPONENT -->
      <v-dialog
        v-model="addVehicleDialog"
        max-width="500px"
        lazy
        @keydown.esc="addVehicleDialog = false"
      >
        <add-vehicle @close="addVehicleDialog = false" parentStore="dockets"></add-vehicle>
      </v-dialog>
      <!-- CLEAR FORM DIALOG -->
      <v-dialog max-width="400px" v-model="clearFormDialog">
        <v-card>
          <v-card-title>
            <div class="headline">Are you sure you want to clear the form and all its allocations?</div>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="clearFormDialog = false" :color="primaryGrey">Cancel</v-btn>
            <v-btn flat color="primary" @click="resetForm(); clearFormDialog = false;">Clear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import BatchValidation from './validation/batchValidation'
import AllocationService from '@/services/requests/allocationService'
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getSites from '@/services/mixins/getMasterFiles/getSites'

import AddDriver from '@/components/drivers/addDriver'
import AddVehicle from '@/components/vehicles/addVehicle'
import DatePickerWrapper from '@/components/ui/datePickerWrapper'
import MakePdf from '@/components/trips/actions/makePdf'

export default {
  name: 'BatchAllocationEntry',
  mixins: [BatchValidation, getContractors, getSites],
  data() {
    return {
      day: true,
      notes: null,
      headerEntry: true,
      showContractorFilter: false,
      addDriverDialog: false,
      addVehicleDialog: false,
      dateMenu: false,
      addingBatch: false,
      docketNotesDialog: false,
      useOverrideCost: false,
      adjustRcti: false,
      adjustBill: false,
      clearFormDialog: false,
    }
  },
  methods: {
    showAddVehicle() {
      if (this.$store.state.user.userAuthClass.contractorWrite)
        this.addVehicleDialog = true
      return
    },
    showAddDriver() {
      if (this.$store.state.user.userAuthClass.contractorWrite)
        this.addDriverDialog = true
      return
    },
    submitBatch() {
      if (!this.$refs.batchForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      if (this.hasAllocations) {
        this.addBatch()
      } else {
        this.snack({
          text: 'Please enter 1 or more Allocations',
          color: 'red',
        })
      }
    },
    addBatch() {
      this.addingBatch = true
      var batch = {
        siteId: this.siteId,
        //spoilId: this.spoilId,
        date: this.date,
        allocations: this.allocations,
        notes: this.notes,
        day: this.day,
      }
      AllocationService.addBatch(batch)
        .then((result) => {
          console.log(result.data)
          this.snack({ text: 'Batch was successfully added!', color: 'green' })
          this.$emit('addedBatch')
          this.resetForm()
          this.addingBatch = false
          this.commitBatch = false
          if (this.$route.name == 'allocationStaging') this.fetchBatches = true
        })
        .catch((err) => {
          this.snack({ text: err.response.data.message, color: 'red' })
          this.addingBatch = false
        })
    },
    resetForm() {
      this.day = true
      this.notes = null
      this.siteId = null
      //this.spoilId = null
      this.date = null
      this.allocations = []
      this.$refs.batchForm.resetValidation()
      this.$refs.siteField.focus()
    },
    preventDefault() {},
    getSiteObj() {
      var id = this.siteId
      var result = this.sites.filter((obj) => {
        return obj.id === id
      })
      this.site = result[0]
      this.projectId = result[0].projectId
    },
    getBatchLinesByDate(date) {
      return AllocationService.getBatchLinesByDate(date)
        .then((result) => {
          this.batchLinesByDate = result.data.result
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  computed: {
    fetchBatches: Store.getSet({
      store: 'allocationStaging',
      prop: 'fetchBatches',
    }),
    contractorId: Store.getSet({
      store: 'batchAllocations',
      prop: 'contractorId',
    }),
    //spoilId: Store.getSet({store: 'batchAllocations', prop: 'spoilId'}),
    siteId: Store.getSet({ store: 'batchAllocations', prop: 'siteId' }),
    projectId: Store.getSet({ store: 'batchAllocations', prop: 'projectId' }),
    site: Store.getSet({ store: 'batchAllocations', prop: 'site' }),
    commitBatch: Store.getSet({
      store: 'batchAllocations',
      prop: 'commitBatch',
    }),
    date: Store.getSet({ store: 'batchAllocations', prop: 'date' }),
    allocations: Store.getSet({
      store: 'batchAllocations',
      prop: 'allocations',
    }),
    batchLinesByDate: Store.getSet({
      store: 'batchAllocations',
      prop: 'batchLinesByDate',
    }),
    //OBJECTS CALCULATED FROM SELECTED DRIVER AND VEHICLE TO GET ASSOCIATED CONTRACTOR ID
    hasAllocations() {
      return !!this.allocations.length
    },
  },
  watch: {
    commitBatch(val) {
      if (!!val) {
        this.submitBatch()
        this.commitBatch = false
      }
    },
    siteId(val) {
      if (!!val) {
        //console.log('Site changed: ',val);
        this.getSiteObj()
      }
    },
    date(val) {
      if (!!val) {
        this.getBatchLinesByDate(val)
      }
    },
  },
  mounted() {},
  components: {
    AddDriver,
    AddVehicle,
    DatePickerWrapper,
  },
}
</script>

<style scoped>
.v-dialog__container {
  align-self: flex-end;
}

.rounded-card {
  border-radius: 6px;
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}
</style>